import {
    METHOD_POST,
    SERVER_URL,
    METHOD_GET,
    METHOD_PUT,
    METHOD_DELETE
} from '../constants/api';
import {
    headersAuthSendReceiveJson,
} from '../headers';
import { apiHandleResponse } from '../../util/api';

const gethospitalServices = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice/list`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const updateHospitalServices = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const syncToShoppable = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice/shoppables/sync`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const gethospitalServicesFromMaster = (options, codeType, facilityId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice/lookup/${codeType}/${facilityId}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const deleteHospitalServices = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const importHospitalServices = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const importAllHospitalServices = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice/all`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const importHospitalServicesFromRedshift = (codeType) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/hospitalservice/import/${codeType}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        //body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

export {
    gethospitalServices,
    gethospitalServicesFromMaster,
    deleteHospitalServices,
    importHospitalServices,
    importAllHospitalServices,
    importHospitalServicesFromRedshift,
    updateHospitalServices,
    syncToShoppable
};